var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-layout" },
    [
      _vm.layout === "splitLayout"
        ? [
            _c("layout-split", {
              attrs: { group: _vm.group, pageData: _vm.pageData }
            })
          ]
        : _vm.layout === "horizontal"
        ? [
            _c("layout-horizontal", {
              attrs: { group: _vm.group, pageData: _vm.pageData }
            })
          ]
        : _vm.layout === "occupants"
        ? [
            _c("layout-occupants", {
              attrs: {
                group: _vm.group,
                pageData: _vm.pageData,
                sectionTitles: _vm.sectionTitles
              }
            })
          ]
        : _vm.layout === "coverage"
        ? [
            _c("layout-coverage", {
              attrs: {
                group: _vm.group,
                pageData: _vm.pageData,
                pageSection: _vm.pageSection
              }
            })
          ]
        : _vm.layout === "mortgage"
        ? [
            _c("layout-mortgage", {
              attrs: {
                group: _vm.group,
                pageData: _vm.pageData,
                pageSection: _vm.pageSection
              }
            })
          ]
        : _vm.layout === "hopolicydetails"
        ? [
            _c("layout-hopolicy-details", {
              attrs: {
                group: _vm.group,
                pageData: _vm.pageData,
                pageSection: _vm.pageSection
              }
            })
          ]
        : [
            _c("layout-default", {
              attrs: { group: _vm.group, pageData: _vm.pageData }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e21d76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e21d76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/SectionLayout.vue
// module id = null
// module chunks = 